import SnackbarService from '@/services/SnackbarService.js';

const IMPERSONATION_EXPIRED_QUERY_PARAM = 'impersonation_expired';
const IMPERSONATION_EXPIRED_MESSAGE =
    'Your impersonation session has expired and you have been returned to your original account.';

let redirectInProgress = false;

function redirectUrlWithNotification(redirectUrl = '/') {
    const url = new URL(redirectUrl, window.location.origin);
    url.searchParams.set(IMPERSONATION_EXPIRED_QUERY_PARAM, '1');

    return `${url.pathname}${url.search}${url.hash}`;
}

function clearNotificationQueryParam() {
    const url = new URL(window.location.href);

    if (!url.searchParams.has(IMPERSONATION_EXPIRED_QUERY_PARAM)) {
        return;
    }

    url.searchParams.delete(IMPERSONATION_EXPIRED_QUERY_PARAM);
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
}

export default {
    isRedirectInProgress() {
        return redirectInProgress;
    },

    handleExpiredResponse(payload = {}) {
        if (redirectInProgress) {
            return;
        }

        redirectInProgress = true;

        const redirect = payload.redirect || '/';

        window.location.replace(redirectUrlWithNotification(redirect));
    },

    maybeShowNotification() {
        const url = new URL(window.location.href);

        if (!url.searchParams.has(IMPERSONATION_EXPIRED_QUERY_PARAM)) {
            redirectInProgress = false;
            return;
        }

        clearNotificationQueryParam();
        redirectInProgress = false;

        SnackbarService.open({
            message: IMPERSONATION_EXPIRED_MESSAGE,
            type: 'is-warning',
            position: 'is-top',
            queue: false,
        });
    },
};

export { IMPERSONATION_EXPIRED_MESSAGE, IMPERSONATION_EXPIRED_QUERY_PARAM };
